/** Container API — Faz 1.4 createApi factory. */
import {createApi} from './_factory'
import type {CommonNs, ContainerNs} from '@shared/types'

const api = createApi('container')

export const ContainerApi = {
  getContainerList: (data: ContainerNs.GetContainerRequest) =>
    api.post<ContainerNs.GetContainerRequest, ContainerNs.Container[]>('list', data),
  addContainer: (data: ContainerNs.AddContainerRequest) =>
    api.post<ContainerNs.AddContainerRequest, ContainerNs.Container[]>('add-container', data),
  changeContainerName: (data: ContainerNs.ChangeContainerNameRequest) =>
    api.post<ContainerNs.ChangeContainerNameRequest, CommonNs.GenericResponse>('change-container-name', data),
  removeContainer: (data: ContainerNs.RemoveContainerRequest) =>
    api.post<ContainerNs.RemoveContainerRequest, ContainerNs.Container[]>('remove-container', data),
}
